import { format } from "date-fns";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { RefreshCw } from "lucide-react";

interface DateSelectorProps {
  fromDate: Date | null;
  toDate: Date | null;
  setFromDate: (date: Date | null) => void;
  setToDate: (date: Date | null) => void;
  handleRefresh: () => void;
}

export const DateSelectors = ({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  handleRefresh,
}: DateSelectorProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-end gap-6 mb-8">
      <div className="flex flex-col gap-1">
        <label className="text-sm">{t("From")}</label>
        <DatePicker
          selected={fromDate}
          onChange={(date) => setFromDate(date)}
          customInput={
            <button className="px-4 py-2 rounded-lg shadow bg-popupLight dark:bg-popupDark text-left min-w-[160px]">
              {fromDate ? format(fromDate, "dd MMM yyyy") : t("Select date")}
            </button>
          }
        />
      </div>

      <div className="flex flex-col gap-1">
        <label className="text-sm">{t("To")}</label>
        <DatePicker
          selected={toDate}
          onChange={(date) => setToDate(date)}
          minDate={fromDate || undefined}
          customInput={
            <button className="px-4 py-2 rounded-lg shadow bg-popupLight dark:bg-popupDark text-left min-w-[160px]">
              {toDate ? format(toDate, "dd MMM yyyy") : t("Select date")}
            </button>
          }
        />
      </div>
      <button
        onClick={handleRefresh}
        title={t("Refresh")}
        className="ml-auto h-10 w-10 flex items-center justify-center rounded-lg shadow bg-popupLight dark:bg-popupDark hover:bg-gray-200 dark:hover:bg-gray-700 transition"
      >
        <RefreshCw size={18} />
      </button>
    </div>
  );
};
